export default __webpack_public_path__ + "static/media/news (4).f4d732f7.webp";